import { Component, ViewChild } from '@angular/core';
import { IModal } from '../../../../components/modals/modal.interface';
import { ModalContainerComponent } from '../../../../components/modals/modal-container.component';

@Component({
  templateUrl: './migrate-workspace-confirmation-modal.component.html',
  styleUrls: ['./migrate-workspace-confirmation-modal.component.scss'],
  standalone: false,
})
export class MigrateWorkspaceConfirmationModalComponent implements IModal {
  @ViewChild(ModalContainerComponent, { static: true })
  public container: ModalContainerComponent;

  public workspacesNames: string[];
  public tenantName: string;
  public confirmed: boolean = false;
  public cancelled: boolean = true;

  constructor() {}

  public init(workspacesNames: string[], tenantName: string): void {
    this.workspacesNames = workspacesNames;
    this.tenantName = tenantName;
  }
}
